export const projects = [
	{
		id: 1,
		name: "InsightLens 🤖",
		date: "2025",
		tech: ["Python", "Streamlit", "Hugging Face", "NLP", "Docker"],
		tagline: "InsightLens is an AI-powered app that leverages Hugging Face Transformers and Streamlit to analyze the sentiment and intent of user feeback in real time.",
		source: "https://github.com/codewithprashantgupta/insightlens-comment-analyzer/tree/main",
	},	
	{
		id: 2,
		name: "Voting App with K8 and Minikube",
		date: "2025",
		tech: ["Kubernetes", "Minikube", "Docker", "AWS"],
		tagline: "Deploying a Voting App on Kubernetes with Minikube and EC2 ",
		source: "https://github.com/codewithprashantgupta/voting-app-project",
	},
	{
		id: 3,
		name: "Python UI Automation",
		date: "2024",
		tech: ["Python", "Gherkin", "Behave", "Selenium"],
		tagline:
			"This project provides a generic framework for implementing UI test automation using Python, Selenium, and BDD (Behavior-Driven Development)",
		source: "https://github.com/codewithprashantgupta/python-bdd-ui-automation",
	},
	{
		id: 4,
		name: "Coming Soon",
		date: "∞",
		tech: ["❔"],
		tagline: "More projects in progress. Also waiting on coffee!!",
	},
];
